// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__Allg8","skillsContainer":"Skills_skillsContainer__jABbh","skills":"Skills_skills__LBpDg"};